import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import * as sequtil from 'molbio/SeqUtil';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import NumericInput from 'ui-library/inputs/NumericInput';
import Modal from 'ui-library/modals/Modal';

interface ReindexModalProps {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  onClickReindex: (current: number, desired: number) => void;
  sequenceLength: number;
  currentIndex: number;
}

/**
 * Modal to confirm reindexing a circular sequence.
 */
export default function ReindexModal({
  onRequestClose,
  onRequestSubmit,
  onClickReindex,
  sequenceLength,
  currentIndex,
}: ReindexModalProps): JSX.Element {
  const [newDisplayIndex, setNewDisplayIndex] = useState<number | null>(1);

  return (
    <Modal
      buttons={[
        {text: 'Cancel', cancel: true},
        {text: 'Re-index', submit: true, disabled: newDisplayIndex == null},
      ]}
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        const modelIndex = sequtil.displayToModel(newDisplayIndex!, 1);
        onClickReindex(currentIndex, modelIndex);
        onRequestSubmit();
      }}
      title="Re-index sequence"
    >
      <p>
        Enter the desired location for the current base (e.g. enter 100 for the current base to become the
        100th base).
      </p>
      <div className={css(styles.indexInputs)}>
        <div className={css(styles.col)}>
          <FieldLabel label="Current location" />
          <p>{sequtil.modelToDisplay(currentIndex, 1)}</p>
        </div>
        <div className={css(styles.col)}>
          <FieldLabel label="New location" />
          <NumericInput
            value={newDisplayIndex}
            onChange={(e) => {
              setNewDisplayIndex(e.target.numericValue);
            }}
            min={1}
            max={sequenceLength + 1}
            required={true}
            validateInteger={true}
            focusOnMount={true}
          />
        </div>
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  indexInputs: {
    display: 'flex',
  },
  col: {
    flex: 1,
  },
});
